import * as React from "react";

const StudentIcon: React.FC<React.SVGProps<SVGElement>> = ({
  width,
  height,
  color,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || "31"}
    height={height || "31"}
    fill="none"
    viewBox="0 0 31 31"
  >
    <path
      stroke={color || "#313131"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M1.484 5.425 9.3 2.583l7.814 2.842-3.551 2.131v2.132s-.948-.71-4.263-.71-4.263.71-4.263.71V7.556zm0 0v5.683"
    ></path>
    <path
      stroke={color || "#313131"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M13.563 8.977v1.263c0 2.441-1.908 4.42-4.263 4.42s-4.262-1.979-4.262-4.42V8.977m14.66 3.595s.69-.502 3.1-.502c2.412 0 3.1.5 3.1.5m-6.2.002v-1.464l-2.583-1.42 5.683-2.132 5.684 2.132-2.583 1.42v1.462m-6.201.002v.409a3.1 3.1 0 0 0 6.2 0v-.41m-5.23 12.746h5.263c1.098 0 1.97-.535 2.755-1.282 1.606-1.529-1.03-2.75-2.034-3.349a7.59 7.59 0 0 0-5.985-.749m-16.503-.409c-1.34.749-4.853 2.276-2.714 4.187 1.046.934 2.21 1.602 3.675 1.602h8.351c1.464 0 2.629-.668 3.675-1.602 2.14-1.91-1.374-3.438-2.714-4.187-3.143-1.755-7.13-1.755-10.273 0"
    ></path>
  </svg>
);

export default React.memo(StudentIcon);
